import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { SdThemeComponent } from '@seb/web-design-system/core';

import { SdSeoComponent } from '../seo/seo.component';
import type { ISeo } from '../seo/seo.interface';

@Component({
  selector: 'sd-seo-wrapper',
  templateUrl: './seo-wrapper.component.html',
  styleUrls: ['./seo-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SdSeoComponent]
})
export class SdSeoWrapperComponent extends SdThemeComponent {
  @Input()
  data: ISeo;
}
